export const setBodyScrollability = (shouldScroll: boolean) => {
  if (shouldScroll) {
    document.body.style.overflow = "";
  } else {
    document.body.style.overflow = "hidden";
  }
};
;
import "/Users/andrejakogovsek/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";